import HoriProjectCard from "../../../components/horiProjectCard/HoriProjectCard";
import VertProjectCard from "../../../components/vertProjectCard/VertProjectCard";
import { projects } from "../../../util/constants/projects";

export default function RecentProjects() {

    const horiProjectsArr = () => {
        let arr = [];

        let length = 3;
        if(projects.length < 3){
            length = projects.length;
        }

        for(let i = 0; i < length; i++){
            arr.push(
                <HoriProjectCard 
                    title={projects[i].title.toUpperCase()}
                    desc={projects[i].type.toUpperCase()}
                    emoji={projects[i].emoji}
                    linkTo="/ProjectDetails"
                    state={{selectedProject: projects[i]}}
                    first={i===0?true:false} 
                />);
        }

        arr.push(
            <HoriProjectCard 
                title="MORE"
                desc="MORE OF MY WORKS"
                emoji="face-with-monocle"
                linkTo="/Projects"
                first={false}
            />
        );

        return arr;

    }


    const vertProjectsArr = () => {
        let arr = [];

        let length = 3;
        if(projects.length < 3){
            length = projects.length;
        }

        for(let i = 0; i < length; i++){
            arr.push(
                <VertProjectCard
                    title={projects[i].title.toUpperCase()}
                    desc={projects[i].type.toUpperCase()}
                    emoji={projects[i].emoji}
                    linkTo="/ProjectDetails"
                    state={{selectedProject: projects[i]}}
                    first={i===0?true:false} 
                    gradientStart={projects[i].gradient[0]}
                    gradientEnd={projects[i].gradient[1]}
                    thumbnail={projects[i].thumbnail}
                    thumbnailAlt={projects[i].thumbnailAlt}
                />);
        }

        arr.push(
            <VertProjectCard
                title="MORE"
                desc="MORE OF MY WORKS"
                emoji="face-with-monocle"
                linkTo="/Projects"
                first={false}
            />
        );

        return arr;

    }


    return(
        <>
            <div
                className="
                    w-screen
                    xl:h-screen
                    bg-home-bg-light
                    dark:bg-home-bg-dark
                    py-8

                    xl:flex
                    xl:flex-col
                "
            >
                <h1 
                    className="
                        text-base
                        sm:text-xl

                        text-home-text-grey
                        font-medium
                        tracking-wider

                        pb-11
                        xl:pb-12
                        xl:pl-20

                        text-center
                        xl:text-left
                    "
                >
                    WHAT I'VE BEEN UP TO
                </h1>

                <div 
                    className="
                        px-6
                        xl:hidden
                    "
                >
                    {
                        horiProjectsArr()
                    }
                </div>
                <div
                    className="
                        flex-grow
                        hidden
                        xl:flex
                        justify-center


                    "
                >
                    {
                        vertProjectsArr()
                    }
                </div>
            </div>
        </>
    );
}